import { Component } from 'react';
import PropTypes from 'prop-types';

class NoSSR extends Component {
  static propTypes={
    children: PropTypes.node,
    onSSR: PropTypes.node
  }

  constructor (...args) {
    super(...args);
    this.state = {
      canRender: false
    };
  }

  componentDidMount () {
    this.setState({ canRender: true });
  }

  render () {
    const { children, onSSR = null } = this.props;
    const { canRender } = this.state;

    return canRender ? children : onSSR;
  }
}

export default NoSSR;